<template>
  <v-container>
    <module-bar title="REPORTE DE EMPLEADO" icon="mdi-file-chart" />

    <v-row v-if="loadingData">
      <v-col class="d-flex justify-center">
        <v-progress-circular indeterminate color="primary" width="1" size="60" />
      </v-col>
    </v-row>

    <v-row v-if="loadedData">
      <v-col>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar empleado" single-line hide-details
          style="max-width: 400px" class="mb-5"></v-text-field>

        <v-card outlined>
          <div class="horizontal-scroll-wrapper">
            <v-data-table :search="search" :headers="headers" :items="employees" :items-per-page="10"
              :mobile-breakpoint="800" @click:row="openDialogTool">
              <template v-slot:[`item.photo`]="{ item }">
                <v-avatar size="40">
                  <v-img :src="item.photo_url" :lazy-src="item.photo_thumbs_url"></v-img>
                </v-avatar>
              </template>

              <template v-slot:[`item.lider`]="{ item }">
                <v-tooltip v-if="item.is_lider" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" color="orange" size="24">
                      mdi-crown-outline
                    </v-icon>
                  </template>
                  <span>Es lider de nomina</span>
                </v-tooltip>
                <v-chip small text-color="white" color="green" v-else-if="item.lider">{{ item.lider }}</v-chip> <!-- nombre de lider-->
                <v-chip v-else small color="default">SIN LIDER</v-chip> <!-- sin lider-->
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon :color="item.enabled ? 'green' : 'red'" size="16" v-bind="attrs" v-on="on">
                      mdi-circle
                    </v-icon>
                  </template>
                  <span>{{ item.enabled ? "Activo" : "Inactivo" }}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </div>
        </v-card>

      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent width="1000">
      <v-card>
        <v-card-text>
          <employee-form schema="edit" :employee="employee" @closeDialogEmployee="closeDialogEmployee"
            @udpateEmployee="udpateEmployee" @deletePayroll="deletePayroll" @remplaceEmployee="remplaceEmployee" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import EmployeeForm from "../../components/Forms/employeeForm.vue";

export default {
  components: {
    ModuleBar,
    EmployeeForm,
  },

  beforeMount() {
    this.loadingData = true;
    this.loadedData = false;
    setTimeout(() => {
      this.$store.dispatch("findEmployeesAction").then((res) => {
        this.employees = res;
        this.loadingData = false;
        this.loadedData = true;
      });
    }, 500);
  },

  data() {
    return {
      employee: null,
      loadingData: true,
      loadedData: false,
      dialog: false,
      search: "",
      click: 0,
      headers: [
        {
          text: "Foto",
          value: "photo",
          //width: "30%",
        },
        {
          text: "Nombre",
          value: "names",
          //width: "30%",
        },
        {
          text: "Status",
          value: "status",
          //width: "10%",
        },
        {
          text: "Lider nomina",
          value: "lider",
          //width: "20%",
        },
        {
          text: "Categoria",
          aling: "center",
          value: "category.name",
          //width: "10%",
        },
        {
          text: "Apodo",
          aling: "center",
          value: "avatar",
          //width: "10%",
        },
        {
          text: "Distrito",
          aling: "center",
          value: "district",
          //width: "10%",
        },
        {
          text: "Provincia",
          value: "location.name",
          //width: "10%",
        },
      ],
      employees: [],
    };
  },

  methods: {
    openDialogTool(value) {
      this.employee = value;
      this.dialog = true;
      this.click++;
    },

    closeDialogEmployee(payload) {
      this.dialog = false;
      this.employee = null;

      if (payload.action == "delete") {
        let index = this.employees.findIndex((x) => x.id == payload.employeeId);
        if (index >= 0) {
          this.employees.splice(index, 1);

          if (this.employees.length == 0) {
            this.employees = [];
          }
        }
      } else if (payload.action == "edit") {
        let index = this.employees.findIndex((x) => x.id == payload.employeeId);
        if (index >= 0) {
          this.employees[index].names = payload.employee.names;
          this.employees[index].last_names = payload.employee.last_names;
          this.employees[index].avatar = payload.employee.avatar;
          this.employees[index].admission_date =
            payload.employee.admission_date.substr(0, 10);
          this.employees[index].responsibility =
            payload.employee.responsibility;
          this.employees[index].recommended = payload.employee.recommended;
          this.employees[index].photo_url = payload.employee.photo_url;
          this.employees[index].enabled = parseInt(payload.employee.enabled);
          this.employees[index].location_id = parseInt(
            payload.employee.location_id
          );
          this.employees[index].category = payload.employee.category;
          this.employees[index].salary = payload.employee.salary;
          this.employees[index].address = payload.employee.address;
          this.employees[index].district = payload.employee.district;
        }
      }
    },

    udpateEmployee(payroll) {
      let lider = "";
      delete payroll.action;

      let employeesFilterByPayroll = this.employees.filter(
        (x) => x.payroll_id == payroll.id
      );

      employeesFilterByPayroll.forEach(element => {
        element.is_lider = false;
        element.lider = null;
        element.payroll = null;

        if (element.id == payroll.lider_id) {
          element.is_lider = true;
          lider = element;
        }
      });

      payroll.employees.forEach(element => {
        let index = this.employees.findIndex((x) => x.id == element.id);
        this.employees[index].payroll = payroll;

        if (index >= 0) {
          this.employees[index].lider = `${lider.names} ${lider.last_names} ${lider.avatar}`;
        }
      });
    },

    deletePayroll(payload) {
      let employeesFindByPayroll = this.employees.filter(
        (x) => x.payroll_id == payload.id
      );

      employeesFindByPayroll.forEach(element => {
        element.is_lider = false;
        element.lider = null;
      });
    },

    remplaceEmployee(employee) {
      this.employee = employee;
      this.employee.lider = `${employee.payroll.lider.names} ${employee.payroll.lider.avatar}`;

      let index = this.employees.findIndex((x) => x.id == employee.id);

      if (index >= 0) {
        this.$set(this.employees, index, employee);
      }
    }
  },
};
</script>


<style scoped>
@media (max-width: 800px) {
  .horizontal-scroll-wrapper {
    display: block;
    white-space: nowrap;
  }

  .horizontal-scroll-wrapper /deep/ table {
    min-width: 600px;
    /* Adjust based on your content */
  }

  /* Forzar la visibilidad del scroll en todos los navegadores */
  .scrollable-table-wrapper::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 7px;
  }

  .scrollable-table-wrapper::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  /* Estilo opcional para el header fijo */
  .v-data-table /deep/ th {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
  }
}
</style>
